<template>
  <div class="login-page">
    <div class="login-wrapper">
      <!-- 左侧品牌区 -->
      <div class="login-brand">
        <div class="brand-content">
          <div class="brand-logo">
            <i class="el-icon-s-marketing"></i>
          </div>
          <h1 class="brand-title">AI骨干人才<br>保留助手</h1>
          <p class="brand-slogan">基于组织数据与优化后的 AI 大模型</p>
          <p class="brand-slogan-sub">帮助管理者更早识别风险并制定保留动作</p>
          <div class="brand-features">
            <div class="feature-item">
              <i class="el-icon-check"></i>
              <span>智能风险评估</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-check"></i>
              <span>团队热力图分析</span>
            </div>
            <div class="feature-item">
              <i class="el-icon-check"></i>
              <span>个性化保留方案</span>
            </div>
          </div>
        </div>
        <div class="brand-decoration"></div>
      </div>

      <!-- 右侧登录区 -->
      <div class="login-form-area">
        <div class="login-card">
          <div class="login-header">
            <h2 class="login-title">欢迎回来</h2>
            <p class="login-subtitle">请输入邮箱和密码登录系统</p>
          </div>

          <el-form :model="form" :rules="rules" ref="formRef" @submit.native.prevent="login" style="margin-bottom: var(--space-lg);">
            <el-form-item prop="email">
              <el-input
                v-model="form.email"
                placeholder="请输入邮箱"
                prefix-icon="el-icon-message"
                size="medium"
              />
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="form.password"
                placeholder="请输入密码"
                prefix-icon="el-icon-lock"
                size="medium"
                type="password"
                show-password
              />
            </el-form-item>
            <el-button
              type="primary"
              size="large"
              class="login-btn"
              :loading="loading"
              @click="login"
            >
              登录
            </el-button>
          </el-form>

        </div>
      </div>
    </div>

    <!-- 首次登录强制改密码弹窗 -->
    <el-dialog
      title="请设置您的新密码"
      :visible.sync="changePwdVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="420px"
    >
      <p style="margin: 0 0 16px 0; font-size: 13px; color: var(--color-text-muted);">
        初始密码为您的邮箱地址，为了账号安全，请设置新密码。
      </p>
      <el-form :model="pwdForm" :rules="pwdRules" ref="pwdRef" @submit.native.prevent="confirmChangePwd">
        <el-form-item prop="newPassword">
          <el-input
            v-model="pwdForm.newPassword"
            placeholder="新密码（至少8位，含字母和数字）"
            type="password"
            show-password
          />
        </el-form-item>
        <el-form-item prop="confirmPassword">
          <el-input
            v-model="pwdForm.confirmPassword"
            placeholder="确认新密码"
            type="password"
            show-password
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="primary" @click="confirmChangePwd">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { rawSet } from '../utils/storage'

export default {
  name: 'Login',
  data() {
    const validateConfirmPwd = (rule, value, callback) => {
      if (value !== this.pwdForm.newPassword) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    const validateNewPwd = (rule, value, callback) => {
      if (!value || value.length < 8) {
        callback(new Error('密码至少 8 位'))
      } else if (!/[a-zA-Z]/.test(value)) {
        callback(new Error('密码需包含英文字母'))
      } else if (!/\d/.test(value)) {
        callback(new Error('密码需包含数字'))
      } else if (value === this.currentEmail) {
        callback(new Error('新密码不能与初始密码相同'))
      } else {
        callback()
      }
    }
    return {
      form: {
        email: '',
        password: ''
      },
      rules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      loading: false,
      changePwdVisible: false,
      currentEmail: '',
      pwdForm: {
        newPassword: '',
        confirmPassword: ''
      },
      pwdRules: {
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: validateNewPwd, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validateConfirmPwd, trigger: 'blur' }
        ]
      },
    }
  },
  methods: {
    login() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        this.loading = true

        const email = this.form.email.trim()
        const password = this.form.password

        // 调用后端真实登录 API
        this.$api.login({ email, password })
          .then(res => {
            const data = res.data
            this.handleLoginSuccess({
              role: data.role,
              email: data.email,
              real_name: data.real_name,
              token: data.token,
              must_change_password: data.must_change_password,
              task_ids: data.task_ids || []
            })
          })
          .catch(err => {
            const msg = (err.response && err.response.data && err.response.data.message) || err.message || '登录失败'
            this.$message.error(msg)
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    async handleLoginSuccess(userInfo) {
      // 清除旧评估记录与临时状态，防止跨账号/跨会话数据污染
      this.$store.commit('SET_EVALUATIONS', [])
      this.$store.commit('SET_CURRENT_EVALUATION', null)

      // 保存用户信息和 Token 到 storage
      this.$store.commit('SET_USER', {
        role: userInfo.role,
        email: userInfo.email,
        real_name: userInfo.real_name,
        token: userInfo.token,
        task_ids: userInfo.task_ids || []
      })
      rawSet('role', userInfo.role)

      if ((userInfo.role === 'manager' || userInfo.role === 'admin' || userInfo.role === 'super_admin') && userInfo.must_change_password) {
        this.currentEmail = userInfo.email
        this.changePwdVisible = true
        return
      }

      if (this.$root.initBackendData) {
        await this.$root.initBackendData()
      }

      if (userInfo.role === 'super_admin') {
        this.$router.push('/admin/tasks')
      } else if (userInfo.role === 'admin') {
        const taskIds = userInfo.task_ids || []
        const allTasks = this.$store.state.tasks.tasksList || []
        const availableTasks = allTasks.filter(t => taskIds.includes(t.task_id) && t.status === 1)
        if (availableTasks.length === 0) {
          this.$message.warning('该账号未被分配任何可用任务，请联系超级管理员')
          return
        }
        this.$router.push('/admin/tasks')
      } else {
        this.$router.push('/')
      }
    },
    confirmChangePwd() {
      this.$refs.pwdRef.validate(valid => {
        if (!valid) return
        // 调用后端设置密码 API
        this.$api.setPassword({
          old_password: this.form.password,
          new_password: this.pwdForm.newPassword
        })
          .then(() => {
            this.$message.success('密码已修改，请使用新密码登录')
            this.changePwdVisible = false
            this.pwdForm.newPassword = ''
            this.pwdForm.confirmPassword = ''
            this.$router.push('/')
          })
          .catch(err => {
            this.$message.error(err.message || '密码修改失败')
          })
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
}

.login-wrapper {
  display: flex;
  width: 900px;
  max-width: 95vw;
  min-height: 560px;
  background: var(--color-surface);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  overflow: hidden;
}

/* 左侧品牌区 */
.login-brand {
  flex: 1;
  background: linear-gradient(135deg, var(--color-accent-light) 0%, var(--color-accent) 100%);
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-3xl);
  overflow: hidden;
}

.brand-decoration {
  position: absolute;
  bottom: -60px;
  right: -60px;
  width: 200px;
  height: 200px;
  border-radius: var(--radius-full);
  background: rgba(255,255,255,0.1);
}

.brand-decoration::before {
  content: '';
  position: absolute;
  top: -40px;
  left: -80px;
  width: 120px;
  height: 120px;
  border-radius: var(--radius-full);
  background: rgba(255,255,255,0.08);
}

.brand-content {
  position: relative;
  z-index: 1;
  color: white;
}

.brand-logo {
  width: 60px;
  height: 60px;
  background: rgba(255,255,255,0.2);
  border-radius: var(--radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  margin-bottom: var(--space-xl);
  backdrop-filter: blur(10px);
}

.brand-title {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 var(--space-md) 0;
}

.brand-slogan {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 var(--space-xs) 0;
  opacity: 0.95;
}

.brand-slogan-sub {
  font-size: 14px;
  margin: 0 0 var(--space-2xl) 0;
  opacity: 0.8;
}

.brand-features {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}

.feature-item {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  font-size: 14px;
  opacity: 0.9;
}

.feature-item i {
  width: 20px;
  height: 20px;
  background: rgba(255,255,255,0.2);
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
}

/* 右侧登录区 */
.login-form-area {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-3xl);
}

.login-card {
  width: 100%;
  max-width: 360px;
}

.login-header {
  text-align: center;
  margin-bottom: var(--space-2xl);
}

.login-title {
  font-size: 24px;
  font-weight: 700;
  color: var(--color-text);
  margin: 0 0 var(--space-sm) 0;
}

.login-subtitle {
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0;
}

.login-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: var(--radius-lg) !important;
}

.login-hint {
  margin-top: var(--space-lg);
  font-size: 12px;
  color: var(--color-text-muted);
  text-align: center;
}

.login-hint p {
  margin: 0 0 var(--space-sm) 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
}

.demo-accounts {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
  display: inline-block;
}

.demo-accounts li {
  line-height: 1.8;
  font-size: 11px;
}

</style>
